import { useCallback, useEffect, useState } from "@wordpress/element";

function getCookie(name, defaultValue = undefined) {
  let matches = document.cookie.match(
    new RegExp(
      "(?:^|; )" +
        name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, "\\$1") +
        "=([^;]*)"
    )
  );
  return matches ? decodeURIComponent(matches[1]) : defaultValue;
}

function setCookie(name, value, options = {}) {
  const { expiresIn, maxAge, sameSite, ...otherOptions } = options || {};

  if (expiresIn) {
    otherOptions.expires = new Date(Date.now() + expiresIn * 1000);
  }
  if (maxAge) {
    otherOptions["max-age"] = maxAge;
  }
  if (sameSite) {
    otherOptions["samesite"] = sameSite;
  }

  const allOptions = {
    path: "/",
    ...otherOptions,
  };
  if (allOptions.expires instanceof Date) {
    allOptions.expires = allOptions.expires.toUTCString();
  }

  let updatedCookie =
    encodeURIComponent(name) + "=" + encodeURIComponent(value);

  for (let optionKey in allOptions) {
    updatedCookie += "; " + optionKey;
    let optionValue = allOptions[optionKey];
    if (optionValue !== true) {
      updatedCookie += "=" + optionValue;
    }
  }

  document.cookie = updatedCookie;
}

export function useCookie(name, defaultValue = "") {
  const cookieValue = getCookie(name, defaultValue);
  const [value, setValue] = useState(cookieValue);
  // Make all useCookies trigger a change across React components
  useEffect(
    function () {
      if (typeof window === "undefined") return;
      const fn = function (evt) {
        setValue(evt.detail);
      };
      window.addEventListener("cookie_value_changed", fn);
      return () => window.removeEventListener("cookie_value_changed", fn);
    },
    [setValue]
  );
  const setCookieValue = useCallback(
    function (value, options = {}) {
      setCookie(name, value, options);
      setValue(value);

      if (typeof window === "undefined") return;
      window.dispatchEvent(
        new CustomEvent("cookie_value_changed", { detail: value })
      );
    },
    [name, setValue]
  );

  return [value, setCookieValue];
}
